import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconLocalPharmacy.tsx
const OutlinedFilledLocalPharmacy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Z" })
});
const OutlinedLocalPharmacy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm293-245Z" })
});
const RoundedFilledLocalPharmacy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M188-74q-48.01 0-76.01-39.5Q84-153 99-199l74-215-74-216q-15-46 12.99-85.5 28-39.5 76.01-39.5h446l45-129q8-24 31-35t46.5-1.5q22.5 8.5 32.5 30t2 44.5l-31 91h35q40.11 0 62.56 33.5Q880-688 868-651l-81 237 74 214q15 46-12.99 86-28 40-76.01 40H188Zm258-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm12-2 82-244-82-244h563l-82 244 82 244H199Z" })
});
const RoundedLocalPharmacy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M188-74q-48.01 0-76.01-39.5Q84-153 99-199l74-215-74-216q-15-46 12.99-85.5 28-39.5 76.01-39.5h446l45-129q8-24 31-35t46.5-1.5q22.5 8.5 32.5 30t2 44.5l-31 91h35q40.11 0 62.56 33.5Q880-688 868-651l-81 237 74 214q15 46-12.99 86-28 40-76.01 40H188Zm258-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm293-246Z" })
});
const SharpFilledLocalPharmacy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Z" })
});
const SharpLocalPharmacy = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M87-74v-90l86-250-86-251v-90h547l65-188 111 43-50 145h113v90l-86 251 86 250v90H87Zm359-185h72v-120h120v-71H518v-120h-72v120H327v71h119v120Zm-259 90h587l-86-245 86-246H187l85.43 246L187-169Zm293-245Z" })
});
const componentMap = {
	outlined: OutlinedLocalPharmacy,
	"outlined-fill": OutlinedFilledLocalPharmacy,
	rounded: RoundedLocalPharmacy,
	"rounded-fill": RoundedFilledLocalPharmacy,
	sharp: SharpLocalPharmacy,
	"sharp-fill": SharpFilledLocalPharmacy
};
const IconLocalPharmacy = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconLocalPharmacy };